var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeliveryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00064 10.3324V2.3332C9.00064 1.97961 8.86015 1.64051 8.61008 1.39049C8.36002 1.14046 8.02085 1 7.6672 1H2.33344C1.97979 1 1.64062 1.14046 1.39056 1.39049C1.14049 1.64051 1 1.97961 1 2.3332V9.6658C1 9.84259 1.07024 10.0121 1.19528 10.1372C1.32031 10.2622 1.48989 10.3324 1.66672 10.3324H3.00016M3.00016 10.3324C3.00016 11.0687 3.59716 11.6656 4.3336 11.6656C5.07004 11.6656 5.66704 11.0687 5.66704 10.3324M3.00016 10.3324C3.00016 9.59609 3.59716 8.9992 4.3336 8.9992C5.07004 8.9992 5.66704 9.59609 5.66704 10.3324M5.66704 10.3324H9.66736M9.66736 10.3324C9.66736 11.0687 10.2644 11.6656 11.0008 11.6656C11.7372 11.6656 12.3342 11.0687 12.3342 10.3324M9.66736 10.3324C9.66736 9.59609 10.2644 8.9992 11.0008 8.9992C11.7372 8.9992 12.3342 9.59609 12.3342 10.3324M12.3342 10.3324H13.6677C13.8445 10.3324 14.0141 10.2622 14.1391 10.1372C14.2642 10.0121 14.3344 9.84259 14.3344 9.6658V7.23271C14.3341 7.08143 14.2824 6.93475 14.1877 6.81675L11.8675 3.91704C11.8052 3.83897 11.7261 3.77591 11.6361 3.73253C11.546 3.68914 11.4474 3.66654 11.3475 3.6664H9.00064",
    stroke: "#313131",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveryIcon);
export default __webpack_public_path__ + "static/media/delivery-icon.1d0ac0631f89796f1d15b4f789b269ff.svg";
export { ForwardRef as ReactComponent };